import React from "react";

/* Ringover Avatar — photo or initials, optional presence dot & ring.
   Sizes mirror the Figma avatar scale. */

const STATUS_COLORS = {
  available: "var(--color-status-available)",
  busy: "var(--color-danger)",
  away: "var(--rg-orange-500)",
  offline: "var(--rg-ink-300)",
};

const PALETTE = [
  ["var(--rg-dashboard-200)", "var(--rg-dashboard-700)"],
  ["var(--rg-empower-200)", "var(--rg-empower-700)"],
  ["var(--rg-ringover-200)", "var(--rg-green-700)"],
  ["rgb(255,224,200)", "var(--rg-orangeventures-600)"],
  ["rgb(231,224,255)", "var(--rg-cadence-500)"],
];

function initials(name = "") {
  return name.trim().split(/\s+/).slice(0, 2).map((w) => w[0] || "").join("").toUpperCase();
}

export function Avatar({ src, name = "", size = 40, status, ring = false, style, ...rest }) {
  const dot = Math.max(8, Math.round(size * 0.28));
  const palette = PALETTE[(name.charCodeAt(0) || 0) % PALETTE.length];

  return (
    <div
      style={{
        position: "relative",
        width: size,
        height: size,
        flexShrink: 0,
        borderRadius: "var(--radius-pill)",
        boxShadow: ring ? "0 0 0 2px var(--surface-card), 0 0 0 4px var(--color-accent)" : "none",
        ...style,
      }}
      {...rest}
    >
      {src ? (
        <img
          src={src}
          alt={name}
          style={{ width: "100%", height: "100%", borderRadius: "inherit", objectFit: "cover", display: "block" }}
        />
      ) : (
        <div
          aria-label={name}
          style={{
            width: "100%", height: "100%", borderRadius: "inherit",
            display: "flex", alignItems: "center", justifyContent: "center",
            background: palette[0], color: palette[1],
            fontFamily: "var(--font-sans)", fontWeight: "var(--weight-semibold)",
            fontSize: Math.round(size * 0.4),
          }}
        >
          {initials(name)}
        </div>
      )}
      {status && (
        <span
          style={{
            position: "absolute", right: -1, bottom: -1,
            width: dot, height: dot, borderRadius: "var(--radius-pill)",
            background: STATUS_COLORS[status] || STATUS_COLORS.offline,
            boxShadow: "0 0 0 2px var(--surface-card)",
          }}
        />
      )}
    </div>
  );
}

export default Avatar;
